/*
  Maisto Caffè — Café-Seiten: Live-Daten und Tischreservierung. Angelegt 10.10.2026.
  Gehört zu sections/maisto-cafe.liquid. Vertrag der Schnittstelle: SPEC §5
  (Edge Function cafe-oeffentlich). Gekapselt (IIFE), keine globalen Namen, keine
  Fremdbibliotheken. Daten aus der Schnittstelle kommen nur per textContent ins DOM.
  11.10.2026 (SPEC-2-website.md): Karten-Auswahl der Themen-Seiten (data-mc-karte="auswahl") und
  Termine (data-mc-termine, info.veranstaltungen – fehlt das Feld, bleibt der Server-Stand stehen).
*/
(function () {
  'use strict';

  var TAGE = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var SPEICHER = 'maisto-cafe:reservierungen';
  var ZEITLIMIT_MS = 15000;
  var TAGE_JE_SEITE = 6;
  var TOKEN_MUSTER = /^[A-Za-z0-9_-]{16,128}$/;

  /*
    10.10.2026 (Prüfbefund „Storno-Token bleibt in der Seiten-URL“): Der Absage-Link trägt den Token im
    Fragment (#storno=…), das kein Server und kein Pixel als Seitenadresse bekommt; Altlinks mit ?storno=
    gehen weiter. Beides wird gleich beim Laden des Skripts aus der Adresse entfernt und nur im Speicher gehalten.
  */
  var STORNO_TOKEN = stornoAusAdresse();

  function stornoAusAdresse() {
    var token = null;
    try {
      var u = new URL(window.location.href);
      var frag = new URLSearchParams(u.hash.replace(/^#/, ''));
      var ausFrag = u.hash.indexOf('storno=') >= 0 ? frag.get('storno') : null;
      var ausQuery = u.searchParams.get('storno');
      token = ausFrag || ausQuery;
      if (ausFrag !== null || u.searchParams.has('storno')) {
        u.searchParams.delete('storno');
        var rest = '';
        if (ausFrag !== null) { frag.delete('storno'); rest = frag.toString(); } else { rest = u.hash.replace(/^#/, ''); }
        window.history.replaceState(window.history.state, '', u.pathname + u.search + (rest ? '#' + rest : ''));
      }
    } catch (e) { token = null; }
    return token && TOKEN_MUSTER.test(token) ? token : null;
  }

  /* ---------- Datum und Text ---------- */

  function berlinHeute() {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    } catch (e) {
      var d = new Date();
      return d.getFullYear() + '-' + zwei(d.getMonth() + 1) + '-' + zwei(d.getDate());
    }
  }
  function zwei(n) { return (n < 10 ? '0' : '') + n; }
  function alsDatum(iso) {
    var p = String(iso).split('-');
    return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12));
  }
  function isoTag(iso) { var w = alsDatum(iso).getUTCDay(); return w === 0 ? 7 : w; }
  function plusTage(iso, n) {
    var d = alsDatum(iso);
    d.setUTCDate(d.getUTCDate() + n);
    return d.getUTCFullYear() + '-' + zwei(d.getUTCMonth() + 1) + '-' + zwei(d.getUTCDate());
  }
  function datumText(iso, mitJahr) {
    var d = alsDatum(iso);
    var t = TAGE[isoTag(iso) - 1] + ', ' + d.getUTCDate() + '. ' + MONATE[d.getUTCMonth()];
    return mitJahr ? t + ' ' + d.getUTCFullYear() : t;
  }
  function uhr(hhmm) {
    var s = String(hhmm || '').slice(0, 5);
    return /:00$/.test(s) ? s.slice(0, 2).replace(/^0/, '') : s.replace(/^0/, '');
  }
  function spanneText(von, bis) { return uhr(von) + ' bis ' + uhr(bis) + ' Uhr'; }
  function zeitenText(zeiten) {
    return (zeiten || []).map(function (z) { return spanneText(z.von, z.bis); }).join(' und ');
  }
  function personenText(n) { return n + (Number(n) === 1 ? ' Person' : ' Personen'); }
  function preisText(wert) {
    var s = String(wert == null ? '' : wert).trim();
    if (!/^\d+([.,]\d{1,2})?$/.test(s)) return s;
    var n = Number(s.replace(',', '.'));
    var teile = n.toFixed(2).split('.');
    return teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + teile[1] + ' €';
  }

  /* ---------- DOM ---------- */

  function el(tag, attrs, kinder) {
    var e = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v == null || v === false) return;
        if (k === 'text') e.textContent = v;
        else if (k === 'class') e.className = v;
        else e.setAttribute(k, v === true ? '' : v);
      });
    }
    (kinder || []).forEach(function (kind) {
      if (kind == null || kind === false) return;
      e.appendChild(typeof kind === 'string' ? document.createTextNode(kind) : kind);
    });
    return e;
  }
  function leeren(e) { while (e && e.firstChild) e.removeChild(e.firstChild); }
  function telLink(cfg, text) { return el('a', { href: 'tel:' + cfg.telefonLink, text: text || cfg.telefon }); }
  function weicheBewegung() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function inSicht(e) {
    if (!e || !e.getBoundingClientRect) return;
    var r = e.getBoundingClientRect();
    if (r.top < 80 || r.top > window.innerHeight * 0.6) {
      e.scrollIntoView({ behavior: weicheBewegung() ? 'auto' : 'smooth', block: 'start' });
    }
  }

  /* ---------- Speicher (nur Zufalls-Token und Datum, keine Namen) ---------- */

  function gemerkteLesen() {
    try {
      var liste = JSON.parse(window.localStorage.getItem(SPEICHER) || '[]');
      if (!Array.isArray(liste)) return [];
      var heute = berlinHeute();
      return liste.filter(function (x) { return x && typeof x.token === 'string' && TOKEN_MUSTER.test(x.token) && x.datum >= heute; });
    } catch (e) { return []; }
  }
  function gemerkteSchreiben(liste) {
    try { window.localStorage.setItem(SPEICHER, JSON.stringify(liste.slice(-5))); } catch (e) { /* privat: egal */ }
  }
  function merken(token, datum) {
    var liste = gemerkteLesen().filter(function (x) { return x.token !== token; });
    liste.push({ token: token, datum: datum });
    gemerkteSchreiben(liste);
  }
  function vergessen(token) {
    gemerkteSchreiben(gemerkteLesen().filter(function (x) { return x.token !== token; }));
  }

  /* ---------- Schnittstelle ---------- */

  function Schnittstelle(cfg) {
    this.cfg = cfg;
  }
  Schnittstelle.prototype.url = function (aktion, params) {
    var q = 'cafe=' + encodeURIComponent(this.cfg.slug) + '&aktion=' + encodeURIComponent(aktion);
    Object.keys(params || {}).forEach(function (k) { q += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); });
    return this.cfg.api + (this.cfg.api.indexOf('?') >= 0 ? '&' : '?') + q;
  };
  /* Antwort: { status, daten } · Netzfehler/Zeitüberschreitung: { status: 0, netz: true } */
  Schnittstelle.prototype.rufen = function (aktion, params, rumpf) {
    var steuer = typeof AbortController === 'function' ? new AbortController() : null;
    var uhrwerk = steuer ? setTimeout(function () { steuer.abort(); }, ZEITLIMIT_MS) : null;
    var opt = { method: rumpf ? 'POST' : 'GET', credentials: 'omit', cache: 'no-store', signal: steuer ? steuer.signal : undefined };
    if (rumpf) {
      // text/plain hält die Anfrage „einfach“ (kein CORS-Vorabruf); der Inhalt ist JSON (SPEC §4).
      opt.headers = { 'Content-Type': 'text/plain;charset=UTF-8' };
      opt.body = JSON.stringify(rumpf);
    }
    return fetch(this.url(aktion, params), opt).then(function (antwort) {
      return antwort.text().then(function (text) {
        var daten = null;
        try { daten = text ? JSON.parse(text) : null; } catch (e) { daten = null; }
        return { status: antwort.status, daten: daten };
      });
    }).catch(function () {
      return { status: 0, netz: true, daten: null };
    }).then(function (erg) {
      if (uhrwerk) clearTimeout(uhrwerk);
      return erg;
    });
  };

  /* ---------- Darstellung der Live-Daten ---------- */

  function oeffnungAm(cafe, iso) {
    var ausnahmen = cafe.ausnahmen || [];
    for (var i = 0; i < ausnahmen.length; i++) {
      var a = ausnahmen[i];
      if (a && a.datum === iso) {
        if (a.geschlossen === true || !a.von) return { offen: false, zeiten: [], hinweis: a.hinweis || '' };
        return { offen: true, zeiten: [{ von: a.von, bis: a.bis }], hinweis: a.hinweis || '' };
      }
    }
    var tag = isoTag(iso);
    var zeiten = (cafe.oeffnungszeiten || []).filter(function (z) { return Number(z.tag) === tag; })
      .map(function (z) { return { von: z.von, bis: z.bis }; });
    return { offen: zeiten.length > 0, zeiten: zeiten, hinweis: '' };
  }

  function naechsterOffen(cafe, heute) {
    for (var i = 1; i <= 21; i++) {
      var iso = plusTage(heute, i);
      var o = oeffnungAm(cafe, iso);
      if (o.offen) {
        var name = i === 1 ? 'Morgen, ' + TAGE[isoTag(iso) - 1] : datumText(iso);
        return name + ', ab ' + uhr(o.zeiten[0].von) + ' Uhr';
      }
    }
    return '';
  }

  function statusZeichnen(root, info) {
    var heute = info.heute || {};
    var offen = !!heute.offen;
    var text = offen
      ? (zeitenText(heute.zeiten) ? ' · ' + zeitenText(heute.zeiten) : '')
      : (function () { var n = naechsterOffen(info.cafe || {}, heute.datum || berlinHeute()); return n ? ' · Wieder geöffnet: ' + n : ''; })();
    root.querySelectorAll('[data-mc-status]').forEach(function (ziel) {
      leeren(ziel);
      ziel.appendChild(el('span', { class: 'mc-status__punkt' + (offen ? ' mc-status__punkt--offen' : ''), 'aria-hidden': 'true' }));
      ziel.appendChild(el('span', null, [el('strong', { text: offen ? 'Heute geöffnet' : 'Heute geschlossen' }), text]));
    });
  }

  function gerichtZeichnen(name, beschreibung, preisKnoten, notiz) {
    var kopf = el('div', { class: 'mc-gericht__kopf' }, [
      el('span', { class: 'mc-gericht__name', text: name }),
      el('span', { class: 'mc-gericht__linie', 'aria-hidden': 'true' }),
      preisKnoten
    ]);
    return el('li', { class: 'mc-gericht' }, [
      kopf,
      beschreibung ? el('p', { class: 'mc-gericht__text', text: beschreibung }) : null,
      notiz ? el('p', { class: 'mc-gericht__notiz', text: notiz }) : null
    ]);
  }

  function vitrineZeichnen(root, info, cfg) {
    var heute = info.heute || {};
    root.querySelectorAll('[data-mc-vitrine]').forEach(function (ziel) {
      leeren(ziel);
      var gruppen = [['Mittagstisch', heute.mittagstisch], ['Kuchen', heute.kuchen]];
      var etwas = false;
      if (heute.offen) {
        gruppen.forEach(function (g) {
          var liste = Array.isArray(g[1]) ? g[1] : [];
          if (!liste.length) return;
          etwas = true;
          ziel.appendChild(el('div', { class: 'mc-vitrine__gruppe' }, [
            el('h3', { class: 'mc-vitrine__titel', text: g[0] }),
            el('ul', { class: 'mc-gerichte' }, liste.map(function (x) {
              return gerichtZeichnen(String(x.name || ''), x.beschreibung ? String(x.beschreibung) : '', el('span', { class: 'mc-gericht__preis' }, [el('span', { class: 'mc-preis', text: preisText(x.preis) })]));
            }))
          ]));
        });
      }
      if (!etwas) {
        ziel.appendChild(heute.offen
          ? el('p', { class: 'mc-vitrine__leer' }, ['Welche Kuchen heute in der Vitrine stehen, sehen Sie vor Ort. Fragen Sie gern auch telefonisch nach: ', telLink(cfg), '.'])
          : el('p', { class: 'mc-vitrine__leer', text: 'Heute ist das Café geschlossen. Am nächsten Öffnungstag zeigen wir hier, welche Kuchen und welcher Mittagstisch frisch auf Sie warten.' }));
      }
    });
  }

  function seiteSichtbar(s) { return s && s.style !== 'fun' && s.style !== 'signup' && s.website !== false; }
  function anker(id) { return 'karte-' + String(id || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  function eintragZeichnen(e, mitNotiz) {
    var preis = el('span', { class: 'mc-gericht__preis' });
    (e.prices || []).forEach(function (p, j) {
      if (j > 0) preis.appendChild(document.createTextNode(' · '));
      preis.appendChild(el('span', { class: 'mc-preis' }, [
        p.label ? el('span', { class: 'mc-gericht__groesse', text: String(p.label) }) : null,
        p.label ? ' ' : null,
        preisText(p.value)
      ]));
    });
    return gerichtZeichnen(String(e.name || ''), e.description ? String(e.description) : '', preis, mitNotiz && e.note ? String(e.note) : '');
  }

  function klein(s) { return String(s == null ? '' : s).trim().toLowerCase(); }

  /* Auswahl „seite“ oder „seite:Abschnitt“, Komma-getrennt (wie die Section). Ohne Treffer bleibt der Server-Stand. */
  function auswahlZeichnen(root, ziel, seiten) {
    var wahl = String(ziel.getAttribute('data-mc-auswahl') || '').split(',').map(function (w) {
      var t = w.split(':');
      return { seite: String(t[0] || '').trim(), abschnitt: klein(t[1]) };
    }).filter(function (w) { return w.seite; });
    var bloecke = [];
    wahl.forEach(function (w) {
      var s = seiten.filter(function (x) { return x.id === w.seite; })[0];
      if (!s) return;
      var abschnitte = (s.sections || []).filter(function (sec) {
        return Array.isArray(sec.entries) && sec.entries.length && (!w.abschnitt || klein(sec.title) === w.abschnitt);
      });
      if (!abschnitte.length) return;
      var titelId = root.id + '-al-' + (bloecke.length + 1);
      var block = el('section', { class: 'mc-karte__seite', 'aria-labelledby': titelId });
      block.appendChild(el('header', { class: 'mc-karte__kopf' }, w.abschnitt ? [
        el('h3', { class: 'mc-karte__titel', id: titelId, text: String(abschnitte[0].title || '') }),
        el('p', { class: 'mc-karte__untertitel', text: String(s.title || '') })
      ] : [
        el('h3', { class: 'mc-karte__titel', id: titelId, text: String(s.title || '') }),
        s.subtitle ? el('p', { class: 'mc-karte__untertitel', text: String(s.subtitle) }) : null
      ]));
      abschnitte.forEach(function (sec) {
        var teil = el('div', { class: 'mc-karte__abschnitt' });
        if (!w.abschnitt && sec.title) teil.appendChild(el('h4', { class: 'mc-karte__abschnitt-titel', text: String(sec.title) }));
        teil.appendChild(el('ul', { class: 'mc-gerichte' }, sec.entries.map(function (e) { return eintragZeichnen(e, true); })));
        block.appendChild(teil);
      });
      bloecke.push(block);
    });
    if (!bloecke.length) return;
    leeren(ziel);
    bloecke.forEach(function (b) { ziel.appendChild(b); });
  }

  function karteZeichnen(root, info, cfg) {
    var seiten = ((info.speisekarte || {}).seiten || []).filter(seiteSichtbar);
    if (!seiten.length) return;
    root.querySelectorAll('[data-mc-karte]').forEach(function (ziel) {
      if (ziel.getAttribute('data-mc-karte') === 'auswahl') { auswahlZeichnen(root, ziel, seiten); return; }
      var auszug = ziel.getAttribute('data-mc-karte') === 'auszug';
      leeren(ziel);
      seiten.slice(0, auszug ? 4 : seiten.length).forEach(function (s, i) {
        var titelId = root.id + '-kl-' + (i + 1);
        var abschnitt = el('section', { class: 'mc-karte__seite', id: anker(s.id), 'aria-labelledby': titelId });
        abschnitt.appendChild(el('header', { class: 'mc-karte__kopf' }, [
          el('h3', { class: 'mc-karte__titel' + (s.titleStyle === 'serif' ? ' mc-karte__titel--serif' : ''), id: titelId, text: String(s.title || '') }),
          s.subtitle ? el('p', { class: 'mc-karte__untertitel', text: String(s.subtitle) }) : null
        ]));
        var gezeigt = 0;
        (s.sections || []).forEach(function (sec) {
          var eintraege = Array.isArray(sec.entries) ? sec.entries : [];
          if (!eintraege.length || (auszug && gezeigt >= 3)) return;
          var block = el('div', { class: 'mc-karte__abschnitt' });
          if (sec.title && !auszug) block.appendChild(el('h4', { class: 'mc-karte__abschnitt-titel', text: String(sec.title) }));
          var ul = el('ul', { class: 'mc-gerichte' });
          eintraege.forEach(function (e) {
            if (auszug && gezeigt >= 3) return;
            gezeigt++;
            ul.appendChild(eintragZeichnen(e, !auszug));
          });
          block.appendChild(ul);
          abschnitt.appendChild(block);
        });
        if (s.footer && !auszug) abschnitt.appendChild(el('p', { class: 'mc-karte__fuss', text: String(s.footer) }));
        ziel.appendChild(abschnitt);
      });
    });
    root.querySelectorAll('[data-mc-sprungmarken]').forEach(function (nav) {
      leeren(nav);
      seiten.forEach(function (s) { nav.appendChild(el('a', { href: '#' + anker(s.id), text: String(s.title || '') })); });
    });
  }

  var ISO_TAG = /^\d{4}-\d{2}-\d{2}$/;
  var UHRZEIT = /^\d{2}:\d{2}/;

  function terminZeit(v) {
    var von = UHRZEIT.test(String(v.von || '')) ? String(v.von).slice(0, 5) : '';
    var bis = UHRZEIT.test(String(v.bis || '')) ? String(v.bis).slice(0, 5) : '';
    if (von && bis) return spanneText(von, bis);
    if (von) return 'ab ' + uhr(von) + ' Uhr';
    return '';
  }

  /* Termine wie in der Section: ab heute, höchstens data-max, ohne Titel oder Datum nicht. */
  function termineZeichnen(root, info) {
    if (!Array.isArray(info.veranstaltungen)) return;
    var heute = berlinHeute();
    var alle = info.veranstaltungen.filter(function (v) {
      return v && v.titel && ISO_TAG.test(String(v.datum || '')) && String(v.datum) >= heute;
    }).sort(function (a, b) {
      var x = String(a.datum) + String(a.von || ''), y = String(b.datum) + String(b.von || '');
      return x < y ? -1 : (x > y ? 1 : 0);
    });
    root.querySelectorAll('[data-mc-termine]').forEach(function (ziel) {
      var max = Math.max(1, Math.min(12, Number(ziel.getAttribute('data-max')) || 12));
      var liste = alle.slice(0, max);
      leeren(ziel);
      if (!liste.length) {
        ziel.appendChild(el('p', { class: 'mc-termine__leer', text: 'Im Moment stehen keine öffentlichen Termine fest. Neue Termine zeigen wir hier, sobald sie geplant sind.' }));
        return;
      }
      ziel.appendChild(el('ul', { class: 'mc-termine' }, liste.map(function (v) {
        var d = alsDatum(v.datum);
        var zeit = terminZeit(v);
        return el('li', { class: 'mc-termin' }, [
          el('p', { class: 'mc-termin__datum', 'aria-hidden': 'true' }, [
            el('span', { class: 'mc-termin__tag', text: TAGE[isoTag(v.datum) - 1].slice(0, 2) }),
            el('span', { class: 'mc-termin__zahl', text: d.getUTCDate() + '.' }),
            el('span', { class: 'mc-termin__monat', text: MONATE[d.getUTCMonth()].slice(0, 3) })
          ]),
          el('div', { class: 'mc-termin__inhalt' }, [
            el('h3', { class: 'mc-termin__titel', text: String(v.titel) }),
            el('p', { class: 'mc-termin__wann', text: datumText(v.datum, true) + (zeit ? ' · ' + zeit : '') }),
            v.beschreibung ? el('p', { class: 'mc-termin__text', text: String(v.beschreibung) }) : null,
            v.preis_text ? el('p', { class: 'mc-termin__preis', text: String(v.preis_text) }) : null
          ])
        ]);
      })));
    });
  }

  function zeitenZeichnen(root, info) {
    var cafe = info.cafe || {};
    if (!Array.isArray(cafe.oeffnungszeiten)) return;
    var heuteTag = isoTag((info.heute || {}).datum || berlinHeute());
    root.querySelectorAll('[data-mc-oeffnungszeiten] tbody').forEach(function (tbody) {
      leeren(tbody);
      for (var t = 1; t <= 7; t++) {
        var zeilen = cafe.oeffnungszeiten.filter(function (z) { return Number(z.tag) === t; });
        var zelle = zeilen.length ? el('td', { text: zeitenText(zeilen) }) : el('td', null, [el('span', { class: 'mc-leise', text: 'geschlossen' })]);
        tbody.appendChild(el('tr', t === heuteTag ? { class: 'mc-heute', 'aria-current': 'date' } : null, [el('th', { scope: 'row', text: TAGE[t - 1] }), zelle]));
      }
    });
    var heute = berlinHeute();
    var kommende = (cafe.ausnahmen || []).filter(function (a) { return a && a.datum >= heute; }).slice(0, 6);
    root.querySelectorAll('[data-mc-ausnahmen]').forEach(function (box) {
      var ul = box.querySelector('ul');
      leeren(ul);
      kommende.forEach(function (a) {
        var was = a.geschlossen === true || !a.von ? 'geschlossen' : spanneText(a.von, a.bis);
        ul.appendChild(el('li', null, [el('strong', { text: datumText(a.datum) + ':' }), ' ' + was + (a.hinweis ? ' – ' + a.hinweis : '')]));
      });
      box.hidden = kommende.length === 0;
    });
  }

  /* ---------- Reservierung ---------- */

  function Reservierung(root, cfg, api) {
    this.root = root;
    this.cfg = cfg;
    this.api = api;
    this.res = root.querySelector('[data-mc-res]');
    this.ohneJs = root.querySelector('[data-mc-ohnejs]');
    this.meldungBox = root.querySelector('[data-mc-meldung]');
    this.ansage = root.querySelector('[data-mc-ansage]');
    this.form = this.res.querySelector('form');
    this.zustand = { tag: null, zeit: null, personen: null, tage: [], sichtbar: TAGE_JE_SEITE, start: Date.now(), maxPersonen: cfg.maxPersonen, sendet: false };
    this.schritt = 1;
  }

  Reservierung.prototype.starten = function () {
    var self = this;
    this.res.hidden = false;
    this.ohneJs.hidden = true;
    this.zustand.start = Date.now();

    this.res.querySelector('[data-mc-mehr-tage]').addEventListener('click', function () {
      self.zustand.sichtbar += TAGE_JE_SEITE;
      self.tageZeichnen(true);
    });
    this.res.querySelectorAll('[data-mc-zurueck]').forEach(function (k) {
      k.addEventListener('click', function () { self.meldung(null); self.zeige(Number(k.getAttribute('data-mc-zurueck'))); });
    });
    this.personenVerdrahten();
    this.form.addEventListener('submit', function (ev) { ev.preventDefault(); self.senden(); });
    this.form.querySelectorAll('input, textarea').forEach(function (feld) {
      feld.addEventListener('input', function () { self.feldFehler(feld.name, null); });
      feld.addEventListener('change', function () { self.feldFehler(feld.name, null); });
    });
    this.res.querySelector('[data-mc-noch-eine]').addEventListener('click', function () {
      self.zustand.tag = null; self.zustand.zeit = null; self.zustand.personen = null;
      self.form.reset();
      self.res.querySelector('[data-mc-fertig]').hidden = true;
      self.res.querySelector('[data-mc-fortschritt]').hidden = false;
      self.tageLaden();
      self.zeige(1);
    });
    this.tageLaden();
  };

  Reservierung.prototype.meldung = function (inhalt, art) {
    var box = this.meldungBox;
    leeren(box);
    if (!inhalt) { box.hidden = true; return; }
    box.className = 'mc-meldung' + (art === 'info' ? ' mc-meldung--info' : '');
    (Array.isArray(inhalt) ? inhalt : [inhalt]).forEach(function (k) { box.appendChild(typeof k === 'string' ? el('p', { text: k }) : k); });
    box.hidden = false;
    inSicht(box);
  };

  Reservierung.prototype.anrufKnopf = function () {
    return el('a', { class: 'mc-knopf mc-knopf--zweit', href: 'tel:' + this.cfg.telefonLink, text: this.cfg.telefon + ' anrufen' });
  };

  Reservierung.prototype.zeige = function (n) {
    this.schritt = n;
    this.res.querySelectorAll('[data-schritt]').forEach(function (s) { s.hidden = Number(s.getAttribute('data-schritt')) !== n; });
    this.res.querySelectorAll('[data-schritt-anzeige]').forEach(function (li) {
      var k = Number(li.getAttribute('data-schritt-anzeige'));
      if (k === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      li.classList.toggle('mc-erledigt', k < n);
    });
    var titel = this.res.querySelector('[data-schritt="' + n + '"] .mc-schritt__titel');
    if (titel) {
      titel.focus({ preventScroll: true });
      inSicht(titel);
    }
    if (this.ansage) this.ansage.textContent = 'Schritt ' + n + ' von 4';
  };

  Reservierung.prototype.tageLaden = function () {
    var self = this;
    var ziel = this.res.querySelector('[data-mc-tage]');
    leeren(ziel);
    ziel.appendChild(el('p', { class: 'mc-laden', text: 'Freie Tage werden geladen …' }));
    var heute = berlinHeute();
    var voraus = Math.min(Number(this.cfg.tageVoraus) || 90, 120);
    return this.api.rufen('tage', { von: heute, bis: plusTage(heute, voraus - 1) }).then(function (erg) {
      if (!erg.daten || !erg.daten.ok || !Array.isArray(erg.daten.tage)) {
        leeren(ziel);
        self.meldung([
          erg.netz
            ? 'Die freien Tage konnten gerade nicht geladen werden. Bitte prüfen Sie Ihre Internetverbindung.'
            : 'Die Online-Reservierung ist im Moment nicht erreichbar.',
          el('p', null, ['Sie können uns jederzeit anrufen: ', telLink(self.cfg), '.']),
          el('div', { class: 'mc-knopfzeile' }, [self.nochmalKnopf(function () { self.meldung(null); self.tageLaden(); }), self.anrufKnopf()])
        ]);
        return;
      }
      self.zustand.tage = erg.daten.tage.filter(function (t) { return t && t.offen; });
      self.tageZeichnen(false);
    });
  };

  Reservierung.prototype.nochmalKnopf = function (fn) {
    var k = el('button', { type: 'button', class: 'mc-knopf mc-knopf--haupt', text: 'Noch einmal versuchen' });
    k.addEventListener('click', fn);
    return k;
  };

  Reservierung.prototype.tageZeichnen = function (fokusAufNeu) {
    var self = this;
    var ziel = this.res.querySelector('[data-mc-tage]');
    var mehr = this.res.querySelector('[data-mc-mehr-tage]');
    var tage = this.zustand.tage;
    var heute = berlinHeute();
    leeren(ziel);
    if (!tage.some(function (t) { return t.buchbar; })) {
      ziel.appendChild(el('p', { class: 'mc-laden' }, ['In den nächsten Wochen ist online leider kein Tisch mehr frei. Bitte rufen Sie uns an: ', telLink(this.cfg), '.']));
      mehr.hidden = true;
      return;
    }
    tage.slice(0, this.zustand.sichtbar).forEach(function (t) {
      var vorsatz = t.datum === heute ? 'Heute' : (t.datum === plusTage(heute, 1) ? 'Morgen' : '');
      var d = alsDatum(t.datum);
      var gross = (vorsatz ? vorsatz + ', ' : '') + TAGE[isoTag(t.datum) - 1];
      var klein = d.getUTCDate() + '. ' + MONATE[d.getUTCMonth()];
      var zusatz = !t.buchbar ? 'online ausgebucht' : (zeitenText(t.zeiten) || '');
      if (t.hinweis) zusatz += (zusatz ? ' · ' : '') + t.hinweis;
      var k = el('button', {
        type: 'button',
        class: 'mc-wahlknopf mc-wahlknopf--tag',
        'data-datum': t.datum,
        'aria-pressed': self.zustand.tag === t.datum ? 'true' : 'false',
        disabled: !t.buchbar,
        'aria-label': gross + ', ' + klein + (zusatz ? ', ' + zusatz : '')
      }, [
        el('span', { class: 'mc-wahlknopf__gross', text: gross }),
        el('span', { class: 'mc-wahlknopf__klein', text: klein }),
        zusatz ? el('span', { class: 'mc-wahlknopf__zusatz', text: zusatz }) : null
      ]);
      k.addEventListener('click', function () { self.tagWaehlen(t); });
      ziel.appendChild(k);
    });
    mehr.hidden = tage.length <= this.zustand.sichtbar;
    if (fokusAufNeu) {
      var neu = ziel.children[this.zustand.sichtbar - TAGE_JE_SEITE];
      if (neu) neu.focus();
    }
  };

  Reservierung.prototype.tagWaehlen = function (t) {
    this.zustand.tag = t.datum;
    this.zustand.zeit = null;
    this.res.querySelectorAll('[data-mc-tage] [data-datum]').forEach(function (k) { k.setAttribute('aria-pressed', k.getAttribute('data-datum') === t.datum ? 'true' : 'false'); });
    this.meldung(null);
    this.res.querySelector('[data-mc-tag-text]').textContent = 'Ihr Tag: ' + datumText(t.datum, true) + '. Tippen Sie auf eine Uhrzeit.';
    this.zeitenLaden();
    this.zeige(2);
  };

  Reservierung.prototype.zeitenLaden = function () {
    var self = this;
    var ziel = this.res.querySelector('[data-mc-zeiten]');
    var datum = this.zustand.tag;
    leeren(ziel);
    ziel.appendChild(el('p', { class: 'mc-laden', text: 'Freie Uhrzeiten werden geladen …' }));
    return this.api.rufen('zeiten', { datum: datum, personen: this.zustand.personen || 1 }).then(function (erg) {
      if (self.zustand.tag !== datum) return;
      leeren(ziel);
      if (!erg.daten || !erg.daten.ok || !Array.isArray(erg.daten.zeiten)) {
        self.meldung([
          'Die Uhrzeiten konnten gerade nicht geladen werden.',
          el('div', { class: 'mc-knopfzeile' }, [self.nochmalKnopf(function () { self.meldung(null); self.zeitenLaden(); }), self.anrufKnopf()])
        ]);
        return;
      }
      var zeiten = erg.daten.zeiten;
      if (!zeiten.some(function (z) { return z.frei; })) {
        ziel.appendChild(el('p', { class: 'mc-laden' }, [
          erg.daten.hinweis ? String(erg.daten.hinweis) + ' ' : '',
          'An diesem Tag ist online leider keine Uhrzeit mehr frei. Bitte wählen Sie einen anderen Tag oder rufen Sie uns an: ', telLink(self.cfg), '.'
        ]));
        return;
      }
      zeiten.forEach(function (z) {
        var k = el('button', {
          type: 'button',
          class: 'mc-wahlknopf mc-wahlknopf--zeit',
          'data-uhrzeit': z.uhrzeit,
          'aria-pressed': self.zustand.zeit === z.uhrzeit ? 'true' : 'false',
          disabled: !z.frei,
          'aria-label': z.uhrzeit + ' Uhr' + (z.frei ? '' : ', schon belegt')
        }, [z.uhrzeit]);
        k.addEventListener('click', function () { self.zeitWaehlen(z.uhrzeit); });
        ziel.appendChild(k);
      });
      if (erg.daten.hinweis) ziel.appendChild(el('p', { class: 'mc-hilfe', style: 'grid-column: 1 / -1', text: String(erg.daten.hinweis) }));
    });
  };

  Reservierung.prototype.zeitWaehlen = function (zeit) {
    this.zustand.zeit = zeit;
    this.res.querySelectorAll('[data-mc-zeiten] [data-uhrzeit]').forEach(function (k) { k.setAttribute('aria-pressed', k.getAttribute('data-uhrzeit') === zeit ? 'true' : 'false'); });
    this.meldung(null);
    this.res.querySelector('[data-mc-zeit-text]').textContent = datumText(this.zustand.tag, false) + ' um ' + zeit + ' Uhr.';
    if (this.zustand.personen) {
      this.personenPruefen(this.zustand.personen);
    } else {
      this.zeige(3);
    }
  };

  Reservierung.prototype.personenVerdrahten = function () {
    var self = this;
    var ziel = this.res.querySelector('[data-mc-personen]');
    leeren(ziel);
    for (var n = 1; n <= this.zustand.maxPersonen; n++) {
      (function (anzahl) {
        var k = el('button', { type: 'button', class: 'mc-wahlknopf mc-wahlknopf--zahl', 'data-personen': String(anzahl), 'aria-pressed': 'false', 'aria-label': personenText(anzahl) }, [String(anzahl)]);
        k.addEventListener('click', function () { self.personenPruefen(anzahl); });
        ziel.appendChild(k);
      })(n);
    }
    var gruppe = this.res.querySelector('[data-mc-gruppe]');
    leeren(gruppe);
    gruppe.appendChild(document.createTextNode('Mehr als ' + this.zustand.maxPersonen + ' Personen? Bitte rufen Sie uns an: '));
    gruppe.appendChild(telLink(this.cfg));
    gruppe.appendChild(document.createTextNode('.'));
  };

  /* Prüft, ob die gewählte Uhrzeit auch für n Personen frei ist; bietet sonst Alternativen an. */
  Reservierung.prototype.personenPruefen = function (n) {
    var self = this;
    this.zustand.personen = n;
    this.res.querySelectorAll('[data-mc-personen] [data-personen]').forEach(function (k) { k.setAttribute('aria-pressed', Number(k.getAttribute('data-personen')) === n ? 'true' : 'false'); });
    this.meldung(null);
    if (n === 1) { this.zeige4(); return; }
    var datum = this.zustand.tag, zeit = this.zustand.zeit;
    this.api.rufen('zeiten', { datum: datum, personen: n }).then(function (erg) {
      if (self.zustand.tag !== datum || self.zustand.zeit !== zeit || self.zustand.personen !== n) return;
      if (!erg.daten || !erg.daten.ok || !Array.isArray(erg.daten.zeiten)) { self.zeige4(); return; } // Server prüft beim Senden ohnehin
      var passt = erg.daten.zeiten.some(function (z) { return z.uhrzeit === zeit && z.frei; });
      if (passt) { self.zeige4(); return; }
      var freie = erg.daten.zeiten.filter(function (z) { return z.frei; });
      var nah = freie.slice().sort(function (a, b) { return Math.abs(minuten(a.uhrzeit) - minuten(zeit)) - Math.abs(minuten(b.uhrzeit) - minuten(zeit)); }).slice(0, 4)
        .sort(function (a, b) { return minuten(a.uhrzeit) - minuten(b.uhrzeit); });
      var zeile = el('div', { class: 'mc-knopfzeile' });
      nah.forEach(function (z) {
        var k = el('button', { type: 'button', class: 'mc-knopf mc-knopf--haupt', text: z.uhrzeit + ' Uhr nehmen' });
        k.addEventListener('click', function () {
          self.zustand.zeit = z.uhrzeit;
          self.meldung(null);
          self.res.querySelector('[data-mc-zeit-text]').textContent = datumText(datum, false) + ' um ' + z.uhrzeit + ' Uhr.';
          self.zeitenLaden();
          self.zeige4();
        });
        zeile.appendChild(k);
      });
      self.meldung([
        'Um ' + zeit + ' Uhr ist für ' + personenText(n) + ' leider kein Tisch mehr frei.',
        nah.length ? 'Diese Uhrzeiten sind an dem Tag noch frei:' : 'An diesem Tag ist für ' + personenText(n) + ' online nichts mehr frei. Bitte rufen Sie uns an.',
        nah.length ? zeile : el('div', { class: 'mc-knopfzeile' }, [self.anrufKnopf()])
      ]);
    });
  };

  function minuten(hhmm) { var p = String(hhmm).split(':'); return (+p[0]) * 60 + (+p[1] || 0); }

  Reservierung.prototype.zeige4 = function () {
    var z = this.zustand;
    var box = this.res.querySelector('[data-mc-zusammenfassung]');
    leeren(box);
    box.appendChild(el('p', null, [
      el('strong', { text: datumText(z.tag, true) }),
      z.zeit + ' Uhr · ' + personenText(z.personen)
    ]));
    this.zeige(4);
  };

  Reservierung.prototype.feldFehler = function (name, text) {
    var feld = this.form.querySelector('[name="' + name + '"]');
    if (!feld) return;
    var fehlerId = (feld.getAttribute('aria-describedby') || '').split(' ').filter(function (id) { return /-f$/.test(id); })[0];
    var box = fehlerId ? document.getElementById(fehlerId) : null;
    if (text) {
      feld.setAttribute('aria-invalid', 'true');
      if (box) { box.textContent = text; box.hidden = false; }
    } else {
      feld.removeAttribute('aria-invalid');
      if (box) { box.textContent = ''; box.hidden = true; }
    }
  };

  Reservierung.prototype.pruefen = function () {
    var f = this.form;
    var name = f.elements.name.value.replace(/\s+/g, ' ').trim();
    var tel = f.elements.telefon.value.trim();
    var ziffern = tel.replace(/\D/g, '');
    var fehler = [];
    if (name.length < 2) fehler.push(['name', 'Bitte geben Sie Ihren Namen ein.']);
    else if (name.length > 80 || /https?:|www\.|[<>]/i.test(name)) fehler.push(['name', 'Bitte geben Sie nur Ihren Namen ein.']);
    if (!tel) fehler.push(['telefon', 'Bitte geben Sie Ihre Telefonnummer ein.']);
    else if (!/^[0-9+()\/\-. ]+$/.test(tel) || ziffern.length < 6 || ziffern.length > 20) fehler.push(['telefon', 'Bitte prüfen Sie die Telefonnummer. Erlaubt sind Ziffern, Leerzeichen und + ( ) / -.']);
    if (!f.elements.einwilligung.checked) fehler.push(['einwilligung', 'Bitte setzen Sie das Häkchen, damit wir Ihre Reservierung speichern dürfen.']);
    var self = this;
    ['name', 'telefon', 'einwilligung'].forEach(function (n) { self.feldFehler(n, null); });
    fehler.forEach(function (x) { self.feldFehler(x[0], x[1]); });
    if (fehler.length) {
      var erstes = f.querySelector('[name="' + fehler[0][0] + '"]');
      if (erstes) erstes.focus();
      return null;
    }
    var bereich = f.querySelector('input[name="bereich"]:checked');
    return {
      cafe: this.cfg.slug,
      datum: this.zustand.tag,
      uhrzeit: this.zustand.zeit,
      personen: this.zustand.personen,
      name: name,
      telefon: tel,
      notiz: f.elements.notiz.value.trim().slice(0, 500),
      bereich: bereich ? bereich.value : 'egal',
      firma: f.elements.mc_hp ? f.elements.mc_hp.value : '', // Falle: Feld heißt mc_hp (kein Autofill), Vertrag bleibt 'firma' (10.10.2026)
      dauer_ms: Date.now() - this.zustand.start,
      einwilligung: true
    };
  };

  Reservierung.prototype.senden = function () {
    var self = this;
    if (this.zustand.sendet) return;
    var rumpf = this.pruefen();
    if (!rumpf) return;
    var knopf = this.form.querySelector('[data-mc-senden]');
    this.zustand.sendet = true;
    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');
    knopf.textContent = 'Wird gesendet …';
    this.meldung(null);
    this.api.rufen('buchen', null, rumpf).then(function (erg) {
      self.zustand.sendet = false;
      knopf.disabled = false;
      knopf.removeAttribute('aria-busy');
      knopf.textContent = 'Tisch verbindlich reservieren';
      var d = erg.daten || {};
      if (erg.status === 200 && d.ok && d.token) { self.fertig(d, rumpf, false); return; }
      // 10.10.2026: Zweites Absenden derselben Reservierung (erste Antwort ging verloren) liefert
      // 200 {ok, doppelt, token:null}. Das ist eine Bestätigung, kein Fehler; ohne Token kein Kalender und kein Merken.
      if (erg.status === 200 && d.ok && d.doppelt) { self.fertig(d, rumpf, true); return; }
      var meldung = d.meldung ? String(d.meldung) : '';
      if (erg.netz) {
        self.meldung([
          'Ihre Reservierung konnte gerade nicht gesendet werden. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es noch einmal.',
          el('p', null, ['Oder rufen Sie uns an: ', telLink(self.cfg), '.']),
          el('div', { class: 'mc-knopfzeile' }, [self.nochmalKnopf(function () { self.senden(); }), self.anrufKnopf()])
        ]);
        return;
      }
      switch (d.code) {
        case 'VOLL':
          self.meldung([meldung || 'Zu dieser Uhrzeit ist leider kein Tisch mehr frei. Bitte wählen Sie eine andere Uhrzeit.', 'Bitte wählen Sie unten eine andere Uhrzeit. Ihre Angaben bleiben erhalten.']);
          self.zustand.zeit = null;
          self.zeitenLaden();
          self.zeige(2);
          return;
        case 'GESCHLOSSEN':
        case 'ZU_SPAET':
          self.meldung(meldung || 'Dieser Tag ist online nicht mehr buchbar. Bitte wählen Sie einen anderen Tag.');
          self.zustand.tag = null;
          self.tageLaden();
          self.zeige(1);
          return;
        case 'ZU_GROSS':
          self.meldung([meldung || 'Für so viele Personen reservieren wir gern telefonisch.', el('div', { class: 'mc-knopfzeile' }, [self.anrufKnopf()])]);
          self.zeige(3);
          return;
        case 'EINGABE':
          if (d.feld && self.form.querySelector('[name="' + d.feld + '"]')) {
            self.feldFehler(d.feld, meldung || 'Bitte prüfen Sie diese Angabe.');
            self.form.querySelector('[name="' + d.feld + '"]').focus();
          } else {
            self.meldung(meldung || 'Bitte prüfen Sie Ihre Angaben.');
          }
          return;
        case 'ZU_VIELE':
          self.meldung([
            meldung || 'Es wurden gerade sehr viele Reservierungen gesendet. Bitte versuchen Sie es später noch einmal.',
            meldung.indexOf(self.cfg.telefon) >= 0 ? null : el('p', null, ['Am schnellsten geht es telefonisch: ', telLink(self.cfg), '.']),
            el('div', { class: 'mc-knopfzeile' }, [self.anrufKnopf()])
          ].filter(Boolean));
          return;
        case 'AUS':
          self.meldung([meldung || 'Die Online-Reservierung ist gerade ausgeschaltet. Bitte rufen Sie uns an.', el('div', { class: 'mc-knopfzeile' }, [self.anrufKnopf()])]);
          return;
        default:
          self.meldung([
            meldung || 'Da ist leider etwas schiefgegangen. Bitte versuchen Sie es noch einmal oder rufen Sie uns an.',
            el('div', { class: 'mc-knopfzeile' }, [self.nochmalKnopf(function () { self.senden(); }), self.anrufKnopf()])
          ]);
      }
    });
  };

  Reservierung.prototype.fertig = function (d, rumpf, doppelt) {
    var r = d.reservierung || {};
    var datum = r.datum || rumpf.datum, zeit = r.uhrzeit || rumpf.uhrzeit, personen = r.personen || rumpf.personen, name = r.name || rumpf.name;
    var titel = doppelt ? 'Diese Reservierung liegt uns bereits vor.' : 'Ihr Tisch ist reserviert.';
    if (!doppelt) merken(String(d.token), datum);
    this.res.querySelector('[data-mc-fertig-titel]').textContent = titel;
    var text = this.res.querySelector('[data-mc-fertig-text]');
    leeren(text);
    text.appendChild(el('strong', { text: datumText(datum, true) }));
    text.appendChild(document.createTextNode('um ' + zeit + ' Uhr · ' + personenText(personen)));
    text.appendChild(el('br'));
    text.appendChild(document.createTextNode('auf den Namen ' + name));
    if (doppelt) {
      text.appendChild(el('br'));
      text.appendChild(document.createTextNode('Telefon ' + rumpf.telefon));
    }
    var ics = this.res.querySelector('[data-mc-ics]');
    ics.hidden = !!doppelt;
    if (doppelt) ics.setAttribute('href', '#'); else ics.setAttribute('href', this.api.url('ics', { token: d.token }));
    this.res.querySelectorAll('[data-mc-fertig-hinweis]').forEach(function (p) {
      p.hidden = p.getAttribute('data-mc-fertig-hinweis') !== (doppelt ? 'doppelt' : 'neu');
    });
    this.res.querySelectorAll('[data-schritt]').forEach(function (s) { s.hidden = true; });
    this.res.querySelector('[data-mc-fortschritt]').hidden = true;
    this.meldung(null);
    var fertig = this.res.querySelector('[data-mc-fertig]');
    fertig.hidden = false;
    fertig.focus({ preventScroll: true });
    inSicht(fertig);
    if (this.ansage) this.ansage.textContent = titel;
    this.form.reset();
    if (this.meine) this.meine.laden();
  };

  /* ---------- Meine Reservierung und Absagen ---------- */

  function Meine(root, cfg, api) {
    this.root = root; this.cfg = cfg; this.api = api;
    this.box = root.querySelector('[data-mc-meine]');
    this.liste = root.querySelector('[data-mc-meine-liste]');
    this.storno = root.querySelector('[data-mc-storno]');
  }

  Meine.prototype.laden = function () {
    var self = this;
    var gemerkt = gemerkteLesen();
    // Vergangene Einträge fallen beim Lesen heraus; so verschwinden sie auch aus dem Speicher.
    try { if (window.localStorage.getItem(SPEICHER) !== null) gemerkteSchreiben(gemerkt); } catch (e) { /* egal */ }
    if (!this.box || !gemerkt.length) { if (this.box) this.box.hidden = true; return; }
    Promise.all(gemerkt.map(function (g) {
      return self.api.rufen('reservierung', { token: g.token }).then(function (erg) { return { g: g, erg: erg }; });
    })).then(function (alle) {
      leeren(self.liste);
      var gezeigt = 0;
      alle.forEach(function (x) {
        var r = x.erg.daten && x.erg.daten.ok ? x.erg.daten.reservierung : null;
        if (!r) { if (x.erg.status === 404) vergessen(x.g.token); return; }
        if (r.status === 'storniert') { vergessen(x.g.token); return; }
        gezeigt++;
        var absagen = el('button', { type: 'button', class: 'mc-knopf mc-knopf--zweit', text: 'Reservierung absagen' });
        absagen.addEventListener('click', function () { self.stornoZeigen(x.g.token); });
        self.liste.appendChild(el('div', { class: 'mc-meine__eintrag' }, [
          el('p', { class: 'mc-meine__text' }, [el('strong', { text: datumText(r.datum, true) }), ' um ' + r.uhrzeit + ' Uhr · ' + personenText(r.personen) + ' · ' + r.name]),
          el('div', { class: 'mc-knopfzeile' }, [
            el('a', { class: 'mc-knopf mc-knopf--zweit', href: self.api.url('ics', { token: x.g.token }), text: 'In meinen Kalender' }),
            absagen
          ])
        ]));
      });
      self.box.hidden = gezeigt === 0;
    });
  };

  Meine.prototype.stornoZeigen = function (token) {
    var self = this;
    var box = this.storno;
    if (!box) return;
    leeren(box);
    box.hidden = false;
    box.appendChild(el('h3', { class: 'mc-storno__titel', text: 'Reservierung absagen' }));
    box.appendChild(el('p', { class: 'mc-laden', role: 'status', text: 'Ihre Reservierung wird geladen …' }));
    box.focus({ preventScroll: true });
    inSicht(box);
    this.api.rufen('reservierung', { token: token }).then(function (erg) {
      leeren(box);
      box.appendChild(el('h3', { class: 'mc-storno__titel', text: 'Reservierung absagen' }));
      var r = erg.daten && erg.daten.ok ? erg.daten.reservierung : null;
      if (!r) {
        box.appendChild(el('p', { role: 'alert' }, [
          erg.netz ? 'Die Reservierung konnte gerade nicht geladen werden. Bitte versuchen Sie es später noch einmal oder rufen Sie uns an: '
            : 'Diese Reservierung haben wir leider nicht gefunden. Bitte rufen Sie uns an: ',
          telLink(self.cfg), '.'
        ]));
        return;
      }
      var was = el('p', { class: 'mc-meine__text' }, [el('strong', { text: datumText(r.datum, true) }), ' um ' + r.uhrzeit + ' Uhr · ' + personenText(r.personen) + ' · auf den Namen ' + r.name]);
      box.appendChild(was);
      if (r.status === 'storniert') {
        vergessen(token);
        box.appendChild(el('p', { role: 'status', text: 'Diese Reservierung ist bereits abgesagt.' }));
        return;
      }
      var ja = el('button', { type: 'button', class: 'mc-knopf mc-knopf--haupt', text: 'Ja, Reservierung absagen' });
      var nein = el('button', { type: 'button', class: 'mc-knopf mc-knopf--zweit', text: 'Nein, Reservierung behalten' });
      var hinweis = el('p', { role: 'alert', hidden: true });
      box.appendChild(el('p', { text: 'Möchten Sie diese Reservierung wirklich absagen?' }));
      box.appendChild(el('div', { class: 'mc-knopfzeile' }, [ja, nein]));
      box.appendChild(hinweis);
      nein.addEventListener('click', function () {
        leeren(box);
        box.hidden = true;
      });
      ja.addEventListener('click', function () {
        ja.disabled = true;
        ja.textContent = 'Wird abgesagt …';
        self.api.rufen('storno', null, { cafe: self.cfg.slug, token: token }).then(function (antwort) {
          if (antwort.daten && antwort.daten.ok) {
            vergessen(token);
            leeren(box);
            box.appendChild(el('h3', { class: 'mc-storno__titel', text: 'Ihre Reservierung ist abgesagt.' }));
            box.appendChild(el('p', { role: 'status', text: 'Danke, dass Sie Bescheid gegeben haben. Wir freuen uns auf ein anderes Mal.' }));
            box.focus({ preventScroll: true });
            self.laden();
            return;
          }
          ja.disabled = false;
          ja.textContent = 'Ja, Reservierung absagen';
          hinweis.hidden = false;
          leeren(hinweis);
          hinweis.appendChild(document.createTextNode(
            (antwort.daten && antwort.daten.meldung ? String(antwort.daten.meldung) + ' ' : (antwort.netz ? 'Die Verbindung hat gerade nicht geklappt. ' : 'Das Absagen hat leider nicht geklappt. ')) + 'Bitte versuchen Sie es noch einmal oder rufen Sie uns an: '));
          hinweis.appendChild(telLink(self.cfg));
          hinweis.appendChild(document.createTextNode('.'));
        });
      });
      ja.focus();
    });
  };

  /* ---------- Start ---------- */

  function einrichten(root) {
    if (root.getAttribute('data-mc-bereit')) return;
    root.setAttribute('data-mc-bereit', '1');
    var cfg = {
      api: root.getAttribute('data-api') || 'https://db.getroast.de/functions/v1/cafe-oeffentlich',
      slug: root.getAttribute('data-slug') || 'maisto-caffe',
      telefon: root.getAttribute('data-telefon') || '030 754 373 46',
      telefonLink: root.getAttribute('data-telefon-link') || '+493075437346',
      maxPersonen: Math.max(1, Math.min(50, Number(root.getAttribute('data-max-personen')) || 8)),
      tageVoraus: 90
    };
    var api = new Schnittstelle(cfg);
    var hatRes = !!root.querySelector('[data-mc-res]');
    var res = hatRes ? new Reservierung(root, cfg, api) : null;
    var meine = hatRes ? new Meine(root, cfg, api) : null;
    if (res) res.meine = meine;

    api.rufen('info').then(function (erg) {
      var info = erg.daten && erg.daten.ok ? erg.daten : null;
      if (info) {
        statusZeichnen(root, info);
        vitrineZeichnen(root, info, cfg);
        karteZeichnen(root, info, cfg);
        zeitenZeichnen(root, info);
        termineZeichnen(root, info);
        var c = info.cafe || {};
        if (c.online_tage_voraus) cfg.tageVoraus = Number(c.online_tage_voraus);
        if (c.online_max_personen && res) {
          res.zustand.maxPersonen = Math.max(1, Math.min(50, Number(c.online_max_personen)));
        }
      }
      if (!res) return;
      if (info && info.cafe && info.cafe.online_aktiv === false) {
        var ohne = root.querySelector('[data-mc-ohnejs]');
        var klein = ohne && ohne.querySelector('.mc-klein');
        if (klein) klein.textContent = 'Online-Reservierungen nehmen wir im Moment nicht an. Telefonisch sind wir gern für Sie da.';
        return;
      }
      res.starten();
    });

    if (meine) {
      if (STORNO_TOKEN) meine.stornoZeigen(STORNO_TOKEN);
      meine.laden();
    }
  }

  function alle() { document.querySelectorAll('[data-mc-cafe]').forEach(einrichten); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
